import { render, staticRenderFns } from "./product.vue?vue&type=template&id=7351ce85"
import script from "./product.ts?vue&type=script&lang=js&external"
export * from "./product.ts?vue&type=script&lang=js&external"
import style0 from "./product.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports